// DS6.20
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import isEqual from 'lodash/isEqual';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import { useDropdownItems } from '../../hooks/useDropdownItems';
import StandardDropdownMenu from '../StandardDropdown/StandardDropdownMenu';
import { PopperDropdownManager } from '../../PopperDropdownLayout';
import PopperBrandedToggleButton from '../../toggles/PopperBrandedToggleButton';
/**
 * Our DS `BrandedButton` with a context menu provided by our dropdown library.
 *
 * You can customize the popper or standarded menu instance via `popperManagerProps` or `standardMenuProps` respectively.
 */ const BrandedButtonWithContextMenu = /*#__PURE__*/ React.memo((_param)=>{
    var { items, popperManagerProps, standardMenuProps } = _param, rest = _object_without_properties(_param, [
        "items",
        "popperManagerProps",
        "standardMenuProps"
    ]);
    const { filteredItems } = useDropdownItems(items);
    const toggleId = useUniqueId();
    const dropdownId = useUniqueId();
    return /*#__PURE__*/ React.createElement(PopperDropdownManager, popperManagerProps, /*#__PURE__*/ React.createElement(PopperBrandedToggleButton, _object_spread({
        id: toggleId,
        "aria-haspopup": "menu",
        "aria-controls": dropdownId
    }, rest)), /*#__PURE__*/ React.createElement(StandardDropdownMenu, _object_spread({
        id: dropdownId,
        role: "menu",
        "aria-labelledby": toggleId,
        menuScrollable: true,
        items: filteredItems
    }, standardMenuProps)));
}, // Deep equal from lodash so we can compare the standard menu and popper manager prop collections
isEqual);
BrandedButtonWithContextMenu.displayName = 'BrandedButtonWithContextMenu';
export default BrandedButtonWithContextMenu;
